/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { LastModifiedInfoBoxFragmentDoc } from '../../documents/LastModifiedInfo.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddProjectMemberModal_ProjectFragment = { __typename: 'Project', id: string, roles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }>, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string } }> };

export type AddProjectMemberModalQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type AddProjectMemberModalQuery = { project: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, roles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }>, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string } }> } | null } };

export type AddProjectMemberModal_OrganisationMemberQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type AddProjectMemberModal_OrganisationMemberQuery = { organisationMemberships: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }> } }> } };

export type AddProjectMemberModal_AddProjectMemberMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  userId: Types.Scalars['ID']['input'];
  roleIds: Array<Types.Scalars['ID']['input']>;
}>;


export type AddProjectMemberModal_AddProjectMemberMutation = { addProjectMemberFromOrganisationMembers: { __typename: 'AddProjectMemberFromOrganisationMembersResult', project: { __typename: 'Project', id: string, lastModified?: { __typename: 'LastModifiedInfo', at: any, by?: { __typename: 'User', id: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null } | null } | null, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string } }> } } };

export const AddProjectMemberModal_ProjectFragmentDoc = gql`
    fragment AddProjectMemberModal_Project on Project {
  id
  roles {
    id
    label
    internalName
  }
  internalStakeholders {
    id
    user {
      id
      title
      description
      website
      isMeister
      familyname
      firstname
      fullname
      locale
    }
  }
}
    `;
export const AddProjectMemberModalDocument = gql`
    query AddProjectMemberModal($projectId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        ...AddProjectMemberModal_Project
      }
    }
  }
}
    ${AddProjectMemberModal_ProjectFragmentDoc}`;

/**
 * __useAddProjectMemberModalQuery__
 *
 * To run a query within a React component, call `useAddProjectMemberModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMemberModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProjectMemberModalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAddProjectMemberModalQuery(baseOptions: Apollo.QueryHookOptions<AddProjectMemberModalQuery, AddProjectMemberModalQueryVariables> & ({ variables: AddProjectMemberModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddProjectMemberModalQuery, AddProjectMemberModalQueryVariables>(AddProjectMemberModalDocument, options);
      }
export function useAddProjectMemberModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddProjectMemberModalQuery, AddProjectMemberModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddProjectMemberModalQuery, AddProjectMemberModalQueryVariables>(AddProjectMemberModalDocument, options);
        }
export function useAddProjectMemberModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddProjectMemberModalQuery, AddProjectMemberModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddProjectMemberModalQuery, AddProjectMemberModalQueryVariables>(AddProjectMemberModalDocument, options);
        }
export type AddProjectMemberModalQueryHookResult = ReturnType<typeof useAddProjectMemberModalQuery>;
export type AddProjectMemberModalLazyQueryHookResult = ReturnType<typeof useAddProjectMemberModalLazyQuery>;
export type AddProjectMemberModalSuspenseQueryHookResult = ReturnType<typeof useAddProjectMemberModalSuspenseQuery>;
export type AddProjectMemberModalQueryResult = Apollo.QueryResult<AddProjectMemberModalQuery, AddProjectMemberModalQueryVariables>;
export const AddProjectMemberModal_OrganisationMemberDocument = gql`
    query AddProjectMemberModal_OrganisationMember($userId: ID!) {
  organisationMemberships(
    offset: 0
    limit: 1
    sorting: [{column: firstname, direction: asc}]
    filters: {statuses: [UNACTIVATED, ACTIVATED], ids: [$userId]}
  ) {
    ... on OrganisationMembershipsConnection {
      edges {
        node {
          id
          defaultProjectRoles {
            id
            label
            internalName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAddProjectMemberModal_OrganisationMemberQuery__
 *
 * To run a query within a React component, call `useAddProjectMemberModal_OrganisationMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMemberModal_OrganisationMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProjectMemberModal_OrganisationMemberQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddProjectMemberModal_OrganisationMemberQuery(baseOptions: Apollo.QueryHookOptions<AddProjectMemberModal_OrganisationMemberQuery, AddProjectMemberModal_OrganisationMemberQueryVariables> & ({ variables: AddProjectMemberModal_OrganisationMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddProjectMemberModal_OrganisationMemberQuery, AddProjectMemberModal_OrganisationMemberQueryVariables>(AddProjectMemberModal_OrganisationMemberDocument, options);
      }
export function useAddProjectMemberModal_OrganisationMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddProjectMemberModal_OrganisationMemberQuery, AddProjectMemberModal_OrganisationMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddProjectMemberModal_OrganisationMemberQuery, AddProjectMemberModal_OrganisationMemberQueryVariables>(AddProjectMemberModal_OrganisationMemberDocument, options);
        }
export function useAddProjectMemberModal_OrganisationMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddProjectMemberModal_OrganisationMemberQuery, AddProjectMemberModal_OrganisationMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddProjectMemberModal_OrganisationMemberQuery, AddProjectMemberModal_OrganisationMemberQueryVariables>(AddProjectMemberModal_OrganisationMemberDocument, options);
        }
export type AddProjectMemberModal_OrganisationMemberQueryHookResult = ReturnType<typeof useAddProjectMemberModal_OrganisationMemberQuery>;
export type AddProjectMemberModal_OrganisationMemberLazyQueryHookResult = ReturnType<typeof useAddProjectMemberModal_OrganisationMemberLazyQuery>;
export type AddProjectMemberModal_OrganisationMemberSuspenseQueryHookResult = ReturnType<typeof useAddProjectMemberModal_OrganisationMemberSuspenseQuery>;
export type AddProjectMemberModal_OrganisationMemberQueryResult = Apollo.QueryResult<AddProjectMemberModal_OrganisationMemberQuery, AddProjectMemberModal_OrganisationMemberQueryVariables>;
export const AddProjectMemberModal_AddProjectMemberDocument = gql`
    mutation AddProjectMemberModal_AddProjectMember($projectId: ID!, $userId: ID!, $roleIds: [ID!]!) {
  addProjectMemberFromOrganisationMembers(
    projectId: $projectId
    userId: $userId
    roleIds: $roleIds
  ) {
    project {
      id
      lastModified {
        ...LastModifiedInfoBox
      }
      internalStakeholders {
        id
        user {
          id
        }
      }
    }
  }
}
    ${LastModifiedInfoBoxFragmentDoc}`;
export type AddProjectMemberModal_AddProjectMemberMutationFn = Apollo.MutationFunction<AddProjectMemberModal_AddProjectMemberMutation, AddProjectMemberModal_AddProjectMemberMutationVariables>;

/**
 * __useAddProjectMemberModal_AddProjectMemberMutation__
 *
 * To run a mutation, you first call `useAddProjectMemberModal_AddProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMemberModal_AddProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMemberModalAddProjectMemberMutation, { data, loading, error }] = useAddProjectMemberModal_AddProjectMemberMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useAddProjectMemberModal_AddProjectMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectMemberModal_AddProjectMemberMutation, AddProjectMemberModal_AddProjectMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectMemberModal_AddProjectMemberMutation, AddProjectMemberModal_AddProjectMemberMutationVariables>(AddProjectMemberModal_AddProjectMemberDocument, options);
      }
export type AddProjectMemberModal_AddProjectMemberMutationHookResult = ReturnType<typeof useAddProjectMemberModal_AddProjectMemberMutation>;
export type AddProjectMemberModal_AddProjectMemberMutationResult = Apollo.MutationResult<AddProjectMemberModal_AddProjectMemberMutation>;
export type AddProjectMemberModal_AddProjectMemberMutationOptions = Apollo.BaseMutationOptions<AddProjectMemberModal_AddProjectMemberMutation, AddProjectMemberModal_AddProjectMemberMutationVariables>;